import React from 'react'
import PropTypes from 'prop-types'
import IconPage from 'components/common/IconPage'
import { Message } from '@paypalcorp/worldready-react'
import { Button, Phone2Icon } from '@paypalcorp/pp-react'
import { connect } from 'react-redux'
import { goToContactUs, goToCancelUri } from 'utils/navigate'
import {
  WEBVIEW_CALLBACK_NAMES,
  shouldTriggerVeniceCallback,
  triggerVeniceCallback,
} from 'utils/mobile'
import { getActionName } from 'utils/content'
import * as fpti from 'utils/fpti'
import { identity } from 'lodash-es'
import { ERROR_PAGE_TYPES } from '@/constants/flow'
import ModalPageLayout from 'components/common/ModalPageLayout'
import { isOldFlowModal, isPayrollPartnerVariantOrIntent } from 'utils/flow'
import COMMON_FPTI_TAGS from '@/constants/fpti-tags/common'

let fptiPage = '@flow:denied'
const fptiEventName = 'ucs_failed_customer_interaction_occurred'
const fptiSummaryBtn = 'summaryBtn'
const { UCS_FLOW_ERROR } = WEBVIEW_CALLBACK_NAMES

class Denied extends React.Component {
  static propTypes = {
    actionType: PropTypes.string,
    flowName: PropTypes.string,
    flowInstanceId: PropTypes.string,
    fptiEntryPoint: PropTypes.string,
    applicationStatus: PropTypes.string,
    errorType: PropTypes.string,
    errorMessage: PropTypes.string,
    errorCode: PropTypes.string,
  }

  UNSAFE_componentWillMount() {
    fptiPage = fptiPage.replace('@flow', getActionName(this.props.actionType))
    fpti.startCPLTracking(fptiPage)
  }

  componentDidMount() {
    const {
      flowName = '',
      flowInstanceId,
      fptiEntryPoint,
      applicationStatus,
      errorType = ERROR_PAGE_TYPES.RISK_DENIED_ERROR,
      errorMessage,
      errorCode,
    } = this.props
    if (shouldTriggerVeniceCallback()) {
      triggerVeniceCallback(UCS_FLOW_ERROR, {
        errorType: ERROR_PAGE_TYPES.RISK_DENIED_ERROR,
        flowName,
      })
    }

    fpti.recordImpression(fptiPage, {
      flowInstanceId,
      fptiEntryPoint,
      errorType,
      errorMessage,
      errorCode,
    })

    fpti.logActivity(fptiPage, {
      flowInstanceId,
      fptiEntryPoint,
      applicationStatus,
      eventName: fptiEventName,
      errorCode,
      errorDesc: `${flowName} - Denied`,
      errorType,
      errorMessage,
    })
    fpti.endCPLTracking()
  }

  handleOnDone = () => {
    const { flowInstanceId, fptiEntryPoint, flowName = '@flow' } = this.props
    fpti.recordClick(fptiPage, fptiSummaryBtn, {
      flowInstanceId,
      fptiEntryPoint,
      ...COMMON_FPTI_TAGS.deniedErrorClickTags(flowName || getActionName(this.props.actionType))
    })

    if (isPayrollPartnerVariantOrIntent()) {
      goToCancelUri()
      return
    }

    goToContactUs()
  }

  render() {
    // Denied page is shared by v1 and v2 flow modals, v2 modal wrapped with FlowModal and Themeprovider by default
    // While v1 modal does not, ModalPageLayout is to provide the ThemeProvider wrapper
    const LayoutElement = isOldFlowModal() ? ModalPageLayout : React.Fragment

    const buttonContent = isPayrollPartnerVariantOrIntent()
      ? 'common.button.ok'
      : 'common.button.contactUs'

    return (
      <LayoutElement>
        <IconPage
          data-testid="denied-page"
          icon={<Phone2Icon size="xl" color="sysColorPrimaryMain" />}
          headerId="error.denied.header"
          contentId="error.denied.content"
          wrapWithModalContent
        >
          <Button data-testid="denied-contact-us-button" onClick={this.handleOnDone}>
            <Message id={buttonContent} />
          </Button>
        </IconPage>
      </LayoutElement>
    )
  }
}

const stateProps = ({ card }, { actionType }) => {
  const { actionType: cardFetchErrorActionType } = card.fetchError || {}
  return {
    actionType: actionType || cardFetchErrorActionType,
  }
}

const actionProps = {
  dispatch: identity,
}

export default connect(stateProps, actionProps)(Denied)
